export default {
  Codigo: null,
  Descripcion: '',
  ElementoGrupoDetalle: [],
};
